import { render, staticRenderFns } from "./SignInPhoneConfirmStep.vue?vue&type=template&id=fdbfa3e6&scoped=true&lang=pug&"
import script from "./SignInPhoneConfirmStep.vue?vue&type=script&lang=ts&"
export * from "./SignInPhoneConfirmStep.vue?vue&type=script&lang=ts&"
import style0 from "./SignInPhoneConfirmStep.vue?vue&type=style&index=0&id=fdbfa3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbfa3e6",
  null
  
)

export default component.exports